export const NEW_COUPON_ERROR = 'Não foi possível adicionar um novo cupom';
export const NEW_COUPON_SUCCESS = 'Seu cupom foi cadastrado com sucesso';
export const NOT_FORBIDEN_VALUE_AND_PERCENT =
  'Escolha entre "Valor fixo" ou  "Percentual"';
export const LIMIT_EXCEEDED = 'Este cupom atingiu o limite de uso';
export const ACTIVE_COUPON = (coupon: string) =>
  `O Cupom ${coupon} foi ativado com sucesso`;
